import React from "react";
import logo from "../assets/logo.png";

export function Footer() {
  return (
    <footer className="pt-20 pb-8 px-6 md:px-10" style={{ background: "#0B0E13", color: "rgba(255,255,255,0.7)" }}>
      <div className="max-w-7xl mx-auto grid sm:grid-cols-2 md:grid-cols-4 gap-10 mb-16">
        <div>
          <div className="flex items-center gap-2.5">
            <img src={logo} alt="Marque logo" style={{ height: 28, width: "auto" }} />
            <span style={{ fontFamily: "Fraunces, serif" }} className="text-2xl text-white">
              BBS<span style={{ color: "#1E9AFF" }}>.</span>
            </span>
          </div>
          <p className="text-sm mt-4 max-w-xs opacity-70">
            A curated home for the world's most-loved brands — authenticated, styled, and delivered.
          </p>
        </div>
        <div>
          <h4 className="text-white uppercase tracking-widest text-xs mb-4">Shop</h4>
          <ul className="space-y-2 text-sm">
            <li><a href="#categories" className="hover:text-white transition-colors">Women</a></li>
            <li><a href="#categories" className="hover:text-white transition-colors">Men</a></li>
            <li><a href="#categories" className="hover:text-white transition-colors">Footwear</a></li>
            <li><a href="#categories" className="hover:text-white transition-colors">New In</a></li>
          </ul>
        </div>
        <div>
          <h4 className="text-white uppercase tracking-widest text-xs mb-4">Company</h4>
          <ul className="space-y-2 text-sm">
            <li><a href="#about" className="hover:text-white transition-colors">About Us</a></li>
            <li><a href="/" className="hover:text-white transition-colors">Journal</a></li>
            <li><a href="/" className="hover:text-white transition-colors">Careers</a></li>
            <li><a href="/" className="hover:text-white transition-colors">Sustainability</a></li>
          </ul>
        </div>
        <div>
          <h4 className="text-white uppercase tracking-widest text-xs mb-4">Help</h4>
          <ul className="space-y-2 text-sm">
            <li><a href="/" className="hover:text-white transition-colors">Shipping & Returns</a></li>
            <li><a href="/" className="hover:text-white transition-colors">Track Order</a></li>
            <li><a href="/" className="hover:text-white transition-colors">Contact</a></li>
            <li><a href="/" className="hover:text-white transition-colors">FAQs</a></li>
          </ul>
        </div>
      </div>
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4 pt-8 text-xs opacity-50" style={{ borderTop: "1px solid rgba(255,255,255,0.1)" }}>
        <p>© 2026 BBS. All rights reserved.</p>
        <p>Made with care, for people who like their brands in one place.</p>
      </div>
    </footer>
  );
}

export default Footer;
